export default class ContractByDateModel {
    idContrato: number;
    idConvenio: number;
    dataContrato: string;
    num_contrato: string;
    idAssociado: string;
    associado: {
        idAssociado: string;
        nome: string;
        cpf: string;
    };
    empresa: {
        nome: string;
    };

    constructor(
        idContrato: number,
        idConvenio: number,
        dataContrato: string,
        num_contrato: string,
        idAssociado: string,
        associado: { idAssociado: string; nome: string; cpf: string },
        empresa: { nome: string }
    ) {
        this.idContrato = idContrato;
        this.idConvenio = idConvenio;
        this.dataContrato = dataContrato;
        this.num_contrato = num_contrato;
        this.idAssociado = idAssociado;
        this.associado = associado;
        this.empresa = empresa;
    }

    static fromApiResponse(data: any): ContractByDateModel {
        return new ContractByDateModel(
            data.id_contrato,
            data.id_convenio,
            data.data_contrato,
            data.num_contrato,
            data.ID_ASSOCIADO,
            {
                idAssociado: data.asociado?.id_associado || '',
                nome: data.asociado?.nome || '',
                cpf: data.asociado?.cpf || ''
            },
            {
                nome: data.empresa?.nome || ''
            }
        );
    }

    static fromApiResponseArray(dataArray: any[]): ContractByDateModel[] {
        return dataArray.map(data => ContractByDateModel.fromApiResponse(data));
    }
}
